import React  from "react";
import { useParams } from 'react-router-dom';
import AccessGroupForm from "./components/AccessGroupForm";

const EditAccessGroup = () => {
	const { groupId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<AccessGroupForm recordId={groupId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditAccessGroup;